export default function createPrivateOfferService(data) {
  return {
    id: data.id,
    name: data.name,
    defaultPrice: data.default_price,
    sourcePrice: data.source_price,
  };
}
